import Grid from "@mui/material/Grid2";
import Skeleton from "@mui/material/Skeleton";
import Divider from "@mui/material/Divider";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import React from "react";
import SkipNextIcon from "@mui/icons-material/SkipNext";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const LoadingInvoicePage = () => {
  return (
    <Stack justifyContent="space-between" height="100%">
      <Grid container={true} spacing={2}>
        <Grid size={6}>
          <Skeleton height="30px" sx={{ transform: "none", marginBottom: "5px" }} />
          <Skeleton height="25px" sx={{ transform: "none" }} />
        </Grid>
        <Grid size={6} sx={{ textAlign: "right" }}>
          <Skeleton height="30px" sx={{ transform: "none" }} />
        </Grid>
        <Divider />
        <Grid size={12}>
          <Skeleton height="300px" sx={{ transform: "none" }} />
        </Grid>
        <Grid size={12}>
          <Skeleton height="300px" sx={{ transform: "none" }} />
        </Grid>
      </Grid>
      <Grid
        container={true}
        spacing={1}
        paddingBottom={2}
        sx={{ position: "sticky", bottom: 0, background: "#fff", marginTop: "24px" }}
      >
        <Grid size={6} container>
          <Button variant="outlined" fullWidth={true} endIcon={<SkipNextIcon />} disabled>
            Skip
          </Button>
        </Grid>
        <Grid size={6}>
          <Button variant="contained" color="gradient" fullWidth={true} endIcon={<ArrowForwardIcon />} disabled>
            Draft
          </Button>
        </Grid>
      </Grid>
    </Stack>
  );
};

export default LoadingInvoicePage;
